import { Component, OnInit, Inject, ViewEncapsulation } from "@angular/core";
import { MatSnackBar, MAT_SNACK_BAR_DATA } from "@angular/material/snack-bar";
import { LoggerService } from '../logger/logger.service';

const log = new LoggerService('CUSTOM MESSAGE COMPONENT');

@Component({
  selector: 'snackbar-message',
  templateUrl: './custom-message.component.html',
  styleUrls: ['./custom-message.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
})
export class CustomMessageComponent implements OnInit { 


  constructor(
    public snackBar: MatSnackBar,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {}

  ngOnInit(){}

  public dismiss(): void {
    this.snackBar._openedSnackBarRef.dismiss();
  }

  public accept(): void {
    this.snackBar._openedSnackBarRef.dismissWithAction();
  }
  

}